import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const HERO_SELECTOR = ".hero-section, .page-hero, .services-page-hero";

/**
 * Keeps floating utilities synchronized: they become available only after the
 * active page hero has completely cleared the fixed navigation bar.
 */
export const usePostHeroVisibility = () => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let frameId = 0;

    const updateVisibility = () => {
      const hero = document.querySelector(HERO_SELECTOR);
      const navbarOffset = window.innerWidth >= 1024 ? 80 : 64;

      if (hero) {
        setVisible(hero.getBoundingClientRect().bottom <= navbarOffset);
        return;
      }

      setVisible(window.scrollY > 160);
    };

    const scheduleUpdate = () => {
      window.cancelAnimationFrame(frameId);
      frameId = window.requestAnimationFrame(updateVisibility);
    };

    setVisible(false);
    frameId = window.requestAnimationFrame(() => {
      frameId = window.requestAnimationFrame(updateVisibility);
    });

    window.addEventListener("scroll", scheduleUpdate, { passive: true });
    window.addEventListener("resize", scheduleUpdate, { passive: true });
    window.addEventListener("captec:immersive-hero-complete", scheduleUpdate);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.removeEventListener("scroll", scheduleUpdate);
      window.removeEventListener("resize", scheduleUpdate);
      window.removeEventListener("captec:immersive-hero-complete", scheduleUpdate);
    };
  }, [location.pathname]);

  return visible;
};

export default usePostHeroVisibility;
